import classNames from "classnames";
import React, { PureComponent } from "react";

import { IStyleSize } from "../Style";

export interface IShadowProps extends Partial<IStyleSize> {}

export class Shadow extends PureComponent<IShadowProps> {
  static defaultProps: Partial<IShadowProps> = {
    size: "md",
  };

  render() {
    const { size, children } = this.props;
    const className = classNames("el-shadow", `el-shadow--size-${size}`);
    return <div className={className}>{children}</div>;
  }
}

export default Shadow;
